<template>
  <div class=" price-container">
    <van-row class="info-line">
      <van-col :span="20">
        <span class="info-title">订单单价(含税)</span>
        <span class="info-price">
          <span>1000</span>
          <span>元/吨</span>
        </span>
      </van-col>
    </van-row>
    <van-row class="info-line">
      <van-col :span="20">
        <span class="info-title">订单金额(含税)</span>
        <span class="info-price">
          <span>1000</span>
          <span>元/吨</span>
        </span>
      </van-col>
    </van-row>
    <van-row class="info-line">
      <van-col :span="20">
        <span class="info-title">ERP可用余额</span>
        <span class="info-price">
          <span>{{56728.2}}</span>
          <span>元</span>
        </span>
      </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  name: 'OrderPrice',
  props: {
    order: Object,
  },
  data() {
    return {

    }
  },
  created() { },
  methods: {},
}
</script>
<style lang="stylus" scoped>
.price-container {
  background-color: #fff;
  padding: 32px 24px;

  .info-line {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #666666;

    .info-title {
      margin-right: 48px;
    }

    .info-price {
      span:nth-child(1) {
        color: #FF5500;
      }
    }
  }

  .info-line:nth-child(2) {
    margin: 40px 0;
  }
}
</style>